import styled from 'styled-components'
import { H4 } from 'components/Text'

export const ButtonSection = styled(H4)`
  display: flex;
  z-index: 1;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  width: calc(100% - 30px);
  margin: 0 auto;
  color: white;
  font-size: 15px;
  font-weight: 300;
  text-transform: none;
  position: sticky;
  bottom: 60px;
  left: 15px;
  border-radius: 8px;
  background-color: #f26722;
  outline: none;

  :hover {
    background: #e66220 !important;
  }

  :active {
    background: #da5d1f !important;
  }
`

export const ButtonLabel = styled.span`
  font-family: 'Montserrat', sans-serif !important;
  font-size: 18px;
  font-weight: 700;
  line-height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`

export const OrderNumber = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  background: rgba(0, 0, 0, 0.2);
  color: #fff;
  font-family: 'Montserrat', sans-serif !important;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  border-radius: 4px;
  position: absolute;
  top: 15px;
  left: 15px;
`

export const Price = styled.span`
  font-family: 'Montserrat', sans-serif !important;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  position: absolute;
  top: 15px;
  right: 15px;
`

export const PriceContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
`

export const OriginalPrice = styled.span`
  font-family: 'Montserrat', sans-serif !important;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  text-decoration: line-through;
  display: flex;
  align-items: right;
  text-align: right;
  justify-content: flex-end;
  position: absolute;
  top: 10px;
  right: 15px;
`

export const DiscountedPrice = styled.span`
  font-family: 'Montserrat', sans-serif !important;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  display: flex;
  align-items: right;
  text-align: right;
  justify-content: flex-end;
  position: absolute;
  top: 23px;
  right: 15px;
`
